module.exports = __webpack_public_path__ + "img/brand-shape-1.80e1c348.png";